import { api } from '../api';

export type ResidentAlertType = 'UNUSED' | 'SCORE_DROP' | 'VOICE_UNUSED';

export interface ResidentAlert {
  type: ResidentAlertType;
  severity: 'INFO' | 'WARNING' | 'CRITICAL';
  /** 대상 프로그램 표시명 (브레인가드테라피 / 보이스웰니스) */
  program: string;
  /** 한 줄 요약 — 배너·목록과 동일 문구 */
  message: string;
  createdAt: string;
  /** 마지막 사용일 (KST YYYY-MM-DD). 조회 구간에 기록이 없으면 null */
  lastUsedAt: string | null;
  /** 최근 windowDays일 중 사용한 일수. 조회 실패 시 null */
  usedDays: number | null;
  windowDays: number | null;
  /** 점수 급락일 때만 채워진다 */
  drop: { todayAvgScore: number; yesterdayAvgScore: number; dropPct: number } | null;
}

/** 입소자 활성 경보 + 근거 */
export async function getResidentAlerts(residentId: string): Promise<ResidentAlert[]> {
  const res = await api.get<ResidentAlert[]>(`/residents/${residentId}/alerts`);
  return res.data;
}
